/* ========================================
   DAYS THEME: LOADING SCREEN SCRIPT
   Controla exibição e fade out do loading
   ======================================== */

class DaysLoadingScreen {
  constructor() {
    this.loader = document.getElementById('days-loading-screen');

    if (!this.loader) return;

    this.init();
  }

  init() {
    // Esconder quando página carregar completamente
    window.addEventListener('load', () => {
      this.hideLoader();
    });

    // Fallback de segurança: esconder após 3 segundos
    // Previne loading infinito se algo der errado
    setTimeout(() => {
      this.hideLoader();
    }, 3000);
  }

  hideLoader() {
    if (this.loader && !this.loader.classList.contains('loaded')) {
      // Adicionar classe para fade out
      this.loader.classList.add('loaded');

      // Remover completamente do DOM após transição (0.5s)
      setTimeout(() => {
        if (this.loader && this.loader.parentNode) {
          this.loader.parentNode.removeChild(this.loader);
        }
      }, 500);
    }
  }
}

// Inicializar imediatamente (antes do DOMContentLoaded)
new DaysLoadingScreen();
